import React, { useEffect } from 'react'
import Header from '../Home/Header/Header'
import Footer from '../Home/Footer/Footer'
import place from '../../Assets/watani-place.jpeg'
import placeAddress from '../../Assets/placeAddress.jpg'
import './Contact.css'
import { 
    FaLocationDot,
    FaPhoneFlip,
    FaEnvelope,

} from "react-icons/fa6";
//animation
import AOS from 'aos'
import 'aos/dist/aos.css'
const Contact = () => {
    useEffect(() => {
        document.title = 'تواصل معنا - مصنع جرانيت وطني'
    })
    useEffect(() => {
        AOS.init({duration: 2000})
    })
  return (
    <>
        <Header />
        <div className='pt-10'>
            <div>
                <h2 className='text-center text-4xl font-bold' data-aos="fade-up">تواصل معنا</h2>
                <p className='text-center font-bold pt-2' data-aos="fade-up">يمكن لك ان تتواصل معنا بسهولة وسنرد على طلبك</p>
                <div className='flex flex-nowrap w-4/5 m-auto justify-center gap-10 mt-12 vsm:flex-wrap vsm:w-full sm:flex-wrap sm:w-full md:flex-wrap md:w-full lg:flex-nowrap lg:w-4/5'>
                    <div className='w-1/2 vsm:w-4/5 sm:w-4/5 md:w-4/5 lg:w-1/2' data-aos="fade-left">
                        <h4 className='font-bold text-xl mb-2'>اترك لنا طلبك</h4>
                        <p className=''>يمكنك ان ترسل طلبك او اي تساؤل عبر تعبئة النموذج التالي وسوف نرد عليك في اسرع وقت ممكن</p>
                        <h4 className='font-bold text-xl mt-5 mb-2'>يمكنك ايضا</h4>
                        <p>ان تزورنا في مقرنا في المنطقة الصناعية ضرما في الرياض</p>
                        <img src={place} alt="شركة جرانيت وطني" className='h-80 w-full object-cover m-auto mt-5' />
                    </div>
                    <div className='w-1/2 vsm:w-4/5 sm:w-4/5 md:w-4/5 lg:w-1/2' data-aos="fade-left">
                        <form method='POST'>
                            <div className='flex flex-col mb-5'>
                                <label for='full-name' className='mb-2'>الاسم الكامل</label>
                                <input type='text' id='full-name' name='fullName' className='border w-full px-3 py-2 outline-0' required/>
                            </div>
                            <div className='flex flex-col mb-5'>
                                <label for='Email' className='mb-2'>البريد الالكتروني</label>
                                <input type='email' id='Email' name='email' className='border w-full px-3 py-2 outline-0' required/>
                            </div>
                            <div className='flex flex-col mb-5'>
                                <label for='message' className='mb-2'>نص الرسالة</label>
                                <textarea id='message' name='message' className='border w-full px-3 py-2 outline-0 h-44' required></textarea>
                            </div>
                            <button type='submit' className='bg-primary px-9 py-3 text-white font-bold'>ارسل رسالة</button>
                        </form>
                    </div>
                </div>
            </div>
            <div className='pt-10 mt-10 bg-fixed relative bg-contact-place bg-center' style={{ backgroundImage: `url(${placeAddress})` }}>
                <div className='relative z-10'>
                    <h2 className='text-center text-4xl font-bold text-white' data-aos="fade-up">مقرنا</h2>
                    <p className='text-center font-bold pt-2 text-white' data-aos="fade-up">يمكنك زيارتنا في مقرنا في اي وقت تشاء</p>
                    <div className='w-4/5 m-auto flex flex-wrap mt-10 justify-center items-center gap-10'>
                        <div className='text-white' data-aos="fade-left">
                            <h4 className='font-extrabold text-7xl pb-4'>الرياض</h4>
                            <div className='mt-5'>
                                <div className='flex items-center pb-5'>
                                    <FaLocationDot className='ml-4' />
                                    <span>المملكة العريبة السعودية الرياض - ضرما - المنطقة الصناعية</span>
                                </div>
                                <div className='flex items-center pb-5'>
                                    <FaPhoneFlip className='ml-4' />
                                    <span>0569526529</span>
                                </div>
                                <div className='flex items-center pb-5'>
                                    <FaEnvelope className='ml-4' />
                                    <span>watani@contact.sa</span>
                                </div>
                            </div>
                        </div>
                        <div className='w-3/5 h-96 vsm:w-full sm:w-full md:w-full lg:w-3/5' data-aos="fade-left">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5776.753439611027!2d32.213831335762265!3d30.58098512402505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f85d629199ddaf%3A0xec2930615cc16507!2sWatany%20Marble%20%26%20Granite%20Factory!5e0!3m2!1sen!2sma!4v1701265309683!5m2!1sen!2sma" style={{border:0}} className='w-full h-full' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </>
  )
}

export default Contact